import React from 'react'
import { Link } from 'react-router-dom'
import HeaderFutureMineralsPriceChange from './HeaderFutureMineralsPriceChange'
import { toCurrentTimezoneHHMMA } from '../../../config/global'

export default function HeaderFutureMineralsPriceCard({ mineral, lng }) {
  return (
    <Link
      key={mineral.id}
      title={`$ ${mineral.price} / ${mineral.unit_symbol}`}
      to={`/${lng}/minerals/${mineral.slug}/prices?CHART=AREA&INTERVAL=MONTH`}
      className={`flex min-w-[256px] flex-col gap-1 border-r-2 border-muted-300 px-4 py-2 hover:bg-muted-300`}
    >
      <div className="flex w-full justify-between rtl:flex-row-reverse">
        <div className="font-bold">{mineral[`name_${lng}`]}</div>
        <div className="font-bold text-secondary-600">{mineral.price}</div>
      </div>
      <div className="flex w-full justify-between rtl:flex-row-reverse">
        <div>{toCurrentTimezoneHHMMA(mineral.date)}</div>
        <HeaderFutureMineralsPriceChange change={mineral.change} />
      </div>
    </Link>
  )
}
